export default __webpack_public_path__ + "static/media/sad-face.d50f8dcf.svg";